export function omit(obj, ...keys) {
  return Object.keys(obj).reduce(
    (result, key) => (keys.includes(key) ? result : { ...result, [key]: obj[key] }),
    {},
  );
}
